import { ProductTemplateType } from "@hermes/api-model-product";
import {
    ImageGalleryAnalyticsEvent,
    getEventCategory,
} from "@hermes/states/product-page";
import { GTMEventData } from "@hermes/utils/analytics";

/**
 * This class is used for change-image event in product-content
 */
export class ProductContentChangeImageEvent extends ImageGalleryAnalyticsEvent {
    /**
     * Overload formatForGTM of inherited class
     * Return formatter for eventaction and eventlabel key
     */
    public formatForGTM(): GTMEventData {
        const eventcategory = getEventCategory(this.eventData);

        let eventaction: string;
        switch (this.eventData.templateType) {
            case ProductTemplateType.Look: {
                eventaction = "Alternative_View_Looks";
                break;
            }
            case ProductTemplateType.Bikini: {
                eventaction = "Alternative_View_Bikini";
                break;
            }
            default: {
                eventaction = "Alternative_View";
                break;
            }
        }
        return {
            ...super.formatForGTM(),
            eventcategory,
            eventaction,
            eventlabel: `${this.eventData.type}_${this.eventData.index + 1}`,
        };
    }
}
